import React from 'react'
import PropTypes from 'prop-types'

import './AloButton.scss'

class AloButton extends React.Component {
  constructor (props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (event) {
    if (this.props.disabled || this.props.processing) return
    if (this.props.onClick) this.props.onClick(event)
  }

  render () {
    let AloButtonClass = 'AloButton'
    if (this.props.link) AloButtonClass += ' AloButton--link'
    if (this.props.underline) AloButtonClass += ' AloButton--underline'
    if (this.props.processing) AloButtonClass += ' AloButton--processing'
    if (this.props.hoverableText) AloButtonClass += ' AloButton--hoverable'
    if (this.props.className) AloButtonClass += ` ${this.props.className}`

    return (
      <button
        className={AloButtonClass}
        disabled={this.props.disabled || this.props.processing}
        onClick={this.handleClick}
        type={this.props.type}
      >
        <span className='AloButton__text'>
          <span className='AloButton__defaultText'>{this.props.children}</span>
          <span className='AloButton__hoverableText'>
            {this.props.hoverableText}
          </span>
        </span>
        <i className='fa fa-spinner fa-spin' />
      </button>
    )
  }
}

AloButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  link: PropTypes.bool,
  underline: PropTypes.bool,
  onClick: PropTypes.func,
  processing: PropTypes.bool,
  type: PropTypes.string,
  hoverableText: PropTypes.string
}

export default AloButton
